import { render, staticRenderFns } from "./MonthAllowancesPlanEdit.vue?vue&type=template&id=5d9399ac&scoped=true&"
import script from "./MonthAllowancesPlanEdit.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9399ac",
  null
  
)

export default component.exports